export const REQUEST_FORMS_DATA = 'REQUEST_FORMS_DATA';
export const RECEIVE_FORMS_DATA = 'RECEIVE_FORMS_DATA';

export const receiveFormsData = (payload) => ({
  type: RECEIVE_FORMS_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/formsActions.js